import { NormalizedNumber } from '@sparkdotfi/common-universal'
import { UseFormReturn } from 'react-hook-form'

import { TransactionOverview } from '../components/TransactionOverview'
import { TxOverview } from '../types'
import { TokenWithBalance } from '@/domain/common/types'
import { Token } from '@/domain/types/Token'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { DialogForm } from '@/features/dialogs/common/components/form/DialogForm'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { links } from '@/ui/constants/links'
import { Info } from '@/ui/molecules/info/Info'

interface UpgradeSusdcViewProps {
  susdc: Token
  susdcBalance: NormalizedNumber
  actionsViewState: ActionsViewState
  form: UseFormReturn<AssetInputSchema>
  formFields: FormFieldsForDialog
  txOverview: TxOverview
}

export function UpgradeSusdcView({
  susdc,
  susdcBalance,
  actionsViewState,
  form,
  formFields,
  txOverview,
}: UpgradeSusdcViewProps) {
  const selectorAssets: TokenWithBalance[] = [{ token: susdc, balance: susdcBalance }]
  return (
    <MultiPanelDialog className="p-8">
      <DialogTitle className="flex items-center gap-2">
        Upgrade to Savings USDC V2
        <Info>
          Upgrade to the new Savings USDC and maximize your earnings with additional Spark Points.{' '}
          <ExternalLink to={links.docs.savings.earningSavings}>Learn more</ExternalLink>
        </Info>
      </DialogTitle>

      <FormAndOverviewWrapper>
        <DialogForm form={form} assetsFields={formFields} selectorAssets={selectorAssets} />
        <TransactionOverview {...txOverview} />
      </FormAndOverviewWrapper>

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
